import {
  Bilibili,
  Facebook,
  Instagram,
  MSN,
  Snapchat,
  Tiktok,
  Youtube,
} from "@/components/SVGIcon";
import { Checkbox } from "@/components/ui/checkbox";
import { Check } from "lucide-react";

const landingPage = import.meta.env.VITE_LANDING_PAGE;

const getPlatforms = (isEnfinity = false) => [
  {
    key: "msn",
    label: "MSN",
    icon: (selected, isEnfinity) => (
      <MSN
        color={`${landingPage === "adcelerate" ? "white" : isEnfinity ? "#3B82F6" : "var(--primary)"}`}
      />
    ),
  },
  {
    key: "youtube",
    label: "Youtube",
    icon: (selected, isEnfinity) => (
      <Youtube
        color={
          selected
            ? `${landingPage === "adcelerate" ? "white" : isEnfinity ? "#3B82F6" : "var(--primary)"}`
            : `${landingPage === "adcelerate" ? "var(--primary)" : isEnfinity ? "black" : "white"}`
        }
      />
    ),
  },
  {
    key: "facebook",
    label: "Facebook",
    icon: (selected, isEnfinity) => (
      <Facebook
        color={
          selected
            ? `${landingPage === "adcelerate" ? "white" : isEnfinity ? "#3B82F6" : "var(--primary)"}`
            : `${landingPage === "adcelerate" ? "var(--primary)" : isEnfinity ? "black" : "white"}`
        }
      />
    ),
  },
  {
    key: "bilibili",
    label: "Bilibili",
    icon: (selected, isEnfinity) => (
      <Bilibili
        color={
          selected
            ? `${landingPage === "adcelerate" ? "white" : isEnfinity ? "#3B82F6" : "var(--primary)"}`
            : `${landingPage === "adcelerate" ? "var(--primary)" : isEnfinity ? "black" : "white"}`
        }
      />
    ),
  },
  {
    key: "instagram",
    label: "Instagram",
    icon: (selected, isEnfinity) => (
      <Instagram
        color={
          selected
            ? `${landingPage === "adcelerate" ? "white" : isEnfinity ? "#3B82F6" : "var(--primary)"}`
            : `${landingPage === "adcelerate" ? "var(--primary)" : isEnfinity ? "black" : "white"}`
        }
      />
    ),
  },
  {
    key: "tiktok",
    label: "TikTok",
    icon: (selected, isEnfinity) => (
      <Tiktok
        color={
          selected
            ? `${landingPage === "adcelerate" ? "white" : isEnfinity ? "#3B82F6" : "var(--primary)"}`
            : `${landingPage === "adcelerate" ? "var(--primary)" : isEnfinity ? "black" : "white"}`
        }
      />
    ),
  },
  {
    key: "snapchatStars",
    label: "Snapchat Stars",
    icon: (selected, isEnfinity) => (
      <Snapchat
        color={
          selected
            ? `${landingPage === "adcelerate" ? "white" : isEnfinity ? "#3B82F6" : "var(--primary)"}`
            : `${landingPage === "adcelerate" ? "var(--primary)" : isEnfinity ? "black" : "white"}`
        }
      />
    ),
  },
];

export default function OptIns({ handleOptInChange, userData, isEnfinity = false }) {
  const platforms = getPlatforms(isEnfinity);
  const allSelected = platforms.every((p) => userData.optIn[p.key]);

  const togglePlatform = (key) => {
    handleOptInChange(key, !userData.optIn[key]);
  };

  const toggleSelectAll = (checked) => {
    platforms.forEach((p) => {
      handleOptInChange(p.key, checked);
    });
  };

  return (
    <>
      <div className="space-y-2 w-full">
        <h1
          className={`text-3xl text-left font-medium ${
            landingPage === "adcelerate" ? "text-primary" : isEnfinity ? "text-black" : "text-white"
          }`}
        >
          Select Opt-ins
        </h1>
        <p
          className={`text-lg ${
            landingPage === "adcelerate" ? "text-primary" : isEnfinity ? "text-black" : ""
          }`}
        >
          Select from the available opt-ins to allow us to promote your content
          across chosen platforms.
        </p>
      </div>

      <div className="flex flex-col gap-6 my-10 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {platforms.map(({ key, label, icon }) => (
            <button
              key={key}
              onClick={() => togglePlatform(key)}
              className={`flex flex-col items-start justify-center gap-4 rounded-lg p-5 text-center font-bold transition-all relative ${
                label === "MSN"
                  ? `border-[3px] pointer-events-none opacity-70 ${
                      landingPage === "adcelerate"
                        ? "border-primary bg-primary text-white"
                        : isEnfinity
                          ? "border-[#3B82F6] bg-white !text-[#3B82F6]"
                          : "border-primary bg-white !text-primary"
                    }`
                  : ""
              } ${
                userData.optIn[key]
                  ? `border-[3px] ${
                      landingPage === "adcelerate"
                        ? "border-primary bg-primary text-white"
                        : isEnfinity
                          ? "border-[#3B82F6] bg-white text-[#3B82F6]"
                          : "border-primary bg-white text-primary"
                    }`
                  : `border-2 opacity-60 ${
                      landingPage === "adcelerate"
                        ? "border-primary text-primary hover:bg-white hover:text-primary hover:opacity-100"
                        : isEnfinity
                          ? "border-gray-200 text-black hover:bg-gray-100 hover:text-black hover:opacity-100"
                          : "border-gray-200 text-white hover:bg-[var(--primaryLight)] hover:text-white hover:opacity-100"
                    }`
              }`}
            >
              <span className="w-6 h-6">{icon(userData.optIn[key], isEnfinity)}</span>
              {label}
              {(userData.optIn[key] || label === "MSN") && (
                <div
                  className={`p-1 rounded-full shadow-lg absolute top-5 right-5 ${
                    landingPage === "adcelerate" 
                      ? "bg-white" 
                      : isEnfinity
                        ? "bg-[#3B82F6]"
                        : "bg-primary"
                  }`}
                >
                  <Check
                    className={`w-4 h-4 ${
                      landingPage === "adcelerate"
                        ? "text-primary"
                        : "text-white"
                    }`}
                  />
                </div>
              )}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Checkbox
            id="selectAll"
            checked={allSelected}
            onCheckedChange={toggleSelectAll}
            className={`bg-white data-[state=checked]:text-white data-[state=checked]:bg-[var(--primary)] ${
              landingPage === "adcelerate" ? "border-[#757575]" : ""
            }`}
          />
          <label
            htmlFor="selectAll"
            className={`text-base font-medium ${
              landingPage === "adcelerate" ? "text-primary" : isEnfinity ? "text-black" : ""
            }`}
          >
            Select all platforms
          </label>
        </div>
      </div>
    </>
  );
}
